import React, { useMemo } from 'react';
import classNames from 'classnames';
import uuidv4 from "../../utils/uuidv4";
/**
 * Bronson RadioButton component.
 * @see https://bronson.vwfs.io/default/components/detail/bronson-radio-button.html
 * @constructor
 */
export function RadioButton({ children, className, id, name, testId, ...otherProps }) {
    /**
     * Generate unique id, if prop `id` is not provided to improve accessibility.
     */
    const radioButtonId = useMemo(() => id ?? uuidv4('radio-button-'), [id]);
    const labelClassNameList = classNames('c-radio', className).trim();
    return (React.createElement("label", { className: labelClassNameList, htmlFor: radioButtonId },
        React.createElement("input", { id: radioButtonId, className: "c-radio__input", type: "radio", name: `${name || 'radio-button'}`, "data-testid": testId, ...otherProps }),
        React.createElement("span", { className: "c-radio__label" }, children)));
}
